import React, { useState, useEffect } from "react";
import NavBar from "../components/NavBar";
import SideMenu from "../components/SideMenu";
import MainContent from "../components/MainContent";
import ProfileWrapper from "../components/ProfileWrapper";
import { useIntercom } from "react-use-intercom";
import { getProfile } from "../api/getProfile";

const Home = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(0);
  const [showProfile, setShowProfile] = useState(false);

  const { boot } = useIntercom();

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleMenuClick = (index: number) => {
    setSelectedMenu(index);
    setShowProfile(false); // Hide profile when sidebar menu is clicked
    setDrawerOpen(!drawerOpen); // this line will close drawer when a menu item is clicked
  };

  const handleProfileClick = () => {
    setShowProfile(true);
  };

  let email = localStorage.getItem("accountEmail");

  async function goodStuff() {
    if (null === email) {
      let profileInfo = await getProfile();
      email = profileInfo.email;
      localStorage.setItem("accountEmail", email);
    }
    boot({
      email: email,
    });
  }

  useEffect(() => {
    goodStuff();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <NavBar toggleDrawer={toggleDrawer} onProfileClick={handleProfileClick} />
      <SideMenu
        open={drawerOpen}
        toggleDrawer={toggleDrawer}
        handleMenuClick={handleMenuClick}
      />
      {showProfile ? (
        <ProfileWrapper />
      ) : (
        <MainContent selectedMenu={selectedMenu} />
      )}
    </div>
  );
};

export default Home;
